import {
  ProductPagesHOC,
  Section,
  SectionMedia,
} from "../components/product-pages";
import { websiteDomain } from "../constants/domain";

const faqs = [
  {
    q: "How can I monetize my YouTube community?",
    a: "To monetize your YouTube community, you can create and share paid premium content for your unlisted YouTube videos. You can also create qoohoo channels, offer multiple subscription plans and post your exclusive YouTube videos.",
  },
  {
    q: "How can I create courses with unlisted YouTube videos?",
    a: "Click courses from homepage (+ icon). Fill in the form details to create your course. To add your unlisted YouTube video link, add lesson and click on the YouTube icon to add the video link. You can create a series of videos in your course as lessons.",
  },
  {
    q: "How can I create premium content with unlisted YouTube videos?",
    a: "You can create premium content from homepage (+ icon) or in the form of premium posts under your qoohoo channels. Click on the YouTube icon to add your unlisted YouTube video link.",
  },
  {
    q: "Do my users need to install qoohoo app to access content?",
    a: "No, you can share the link of your created content on any platform and users can access once paid for it.",
  }
];

const pageConfig = {
  seo: {
    title: "YouTube Creators • qoohoo",
    description:
      "Earn from your YouTube unlisted videos with qoohoo. YouTubers can monetise their unlisted videos and playlists to create courses and earn from their YouTube community tab. With complete privacy of your unlisted video, monetise your YouTube videos with full potential on qoohoo.",
    url: `${websiteDomain}/monetise-youtube-videos`,
    ogImageAsset: "/assets/images/monetise-youtube-videos-og.png",
  },
  hero: {
    heading: (
      <>
        Earn from your
        <br className="hidden md:block" /> {" "}
        <span className="text-[#FF0000]">YouTube videos</span>
      </>
    ),
    description:
      "Start monetising your subscribers by sharing unlisted YouTube videos",
    buttonIcon: "",
    buttonText: "Download Now",
    onButtonClick: () => {
      // console.log("qoohoo download link");
    },
  },
  process: {
    heading: "Boost your potential",
    description:
      "You can do much more with your YouTube unlisted videos",
    processes: [
      {
        title: "Create Premium Content",
        description:
          "Get a new way to earn from your unlisted YouTube videos. Create premium content with your YouTube videos on qoohoo and share qoohoo link on any platform.",
        backgroundColor: "#ff8383",
      },
      {
        title: "Complete privacy of videos",
        description:
          "Share unlisted YouTube videos on qoohoo without exposing the link to your audience. Monetise your audience freely with complete privacy of your content inside qoohoo.",
        backgroundColor: "#F2E787",
      },
      {
        title: "Bundle up with courses",
        description:
          "Create courses from your unlisted YouTube playlist and personalise your community experience with your true paying audience.",
        backgroundColor: "#87F292",
      },
    ],
  },
  // explainer: {
  //   heading: "Checkout the video below",
  //   description: (
  //     <>
  //       Get paid from your unlisted YouTube videos without exposing the link. Check out how!
  //     </>
  //   ),
  //   mediaUrl: {
  //     src: "https://youtu.be/DoUAob5RWfY",
  //     isYoutubeLink: true,
  //   },
  // },
  sections: [
    {
      [Section.sideType.mediaType]: {
        type: SectionMedia.mediaType.IMAGE,
        asset: "/assets/images/youtube-section-1.png",
        alt: "WhatsApp Groups",
      },
      [Section.sideType.textType]: {
        heading: "Launch your premium content",
        description: (
          <>
            Premium content makes it easy for creators to earn from their unlisted YouTube videos. Share your YouTube unlisted videos as premium content with complete privacy and earn from your YouTube community.
          </>
        ),
      },
      isDarkBackground: true,
      firstSideInDesktop: Section.sideType.mediaType,
      firstSideInMobile: Section.sideType.textType,
    },
    {
      [Section.sideType.mediaType]: {
        type: SectionMedia.mediaType.IMAGE,
        asset: "/assets/images/youtube-section-2.png",
      },
      [Section.sideType.textType]: {
        heading: "Launch paid courses with YouTube videos",
        description: (
          <>
            Launch your paid courses from your unlisted YouTube playlist. Give paid access to your audience in app and web as well.
          </>

        ),
      },
      isDarkBackground: true,
      firstSideInDesktop: Section.sideType.textType,
      firstSideInMobile: Section.sideType.textType,
    },

  ],
  reviews: [

  ],
  reviewWavePath: "/assets/images/wave-misc.svg",
  footerWavePath: "/assets/images/wave.svg",
  faqs: faqs,
  faqQuestionBackground: "#EBFBF0",
  faqAnswerBackground: "#F8FBFF",
  isLightMode: false,
  bodyBackgroundColor: "#16191B",
  bodyAccentColor: "#FF0000",
  reviewsBgColor: "#C2E1F2",
  footerBackground: "#F8FBFF",
};

const MonetiseYoutubeVideos = ProductPagesHOC(pageConfig);

export default MonetiseYoutubeVideos;
